<template>
  <main class="error-log-page">
    <section class="soft-card table-panel">
      <div class="toolbar">
        <el-input
          v-model="searchQuery"
          placeholder="搜索 request_id / 账号代码或名称..."
          size="small"
          clearable
          class="search-input"
          @keyup.enter.native="onSearch"
          @clear="onSearch"
        />
        <el-date-picker
          v-model="startTime"
          type="datetime"
          placeholder="开始时间"
          size="small"
          value-format="yyyy-MM-dd HH:mm:ss"
          class="date-picker-item"
        />
        <el-date-picker
          v-model="endTime"
          type="datetime"
          placeholder="结束时间"
          size="small"
          value-format="yyyy-MM-dd HH:mm:ss"
          class="date-picker-item"
        />
        <el-button size="small" plain icon="el-icon-search" @click="onSearch">搜索</el-button>
        <el-button size="small" plain @click="onReset">重置</el-button>
      </div>

      <div class="desktop-only">
        <el-table :data="logs" size="small" style="width: 100%">
          <el-table-column type="index" label="序号" width="60" :index="pageIndex" />
          <el-table-column label="类名" width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-size: 12px;">{{ scope.row.className }}</span>
            </template>
          </el-table-column>
          <el-table-column label="错误信息" min-width="240">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.errorMessage || '-'" placement="top" :disabled="!scope.row.errorMessage">
                <div class="error-msg" :title="scope.row.errorMessage">{{ scope.row.errorMessage || '-' }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="堆栈" width="80">
            <template slot-scope="scope">
              <el-button v-if="scope.row.stackTrace" size="small" type="text" @click="showStack(scope.row)">查看</el-button>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="accountUsername" label="账号代码" width="100" />
          <el-table-column prop="accountName" label="账号名称" width="120" />
          <el-table-column prop="modelName" label="模型" width="160" show-overflow-tooltip />
          <el-table-column prop="requestId" label="Request ID" width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.requestId" class="request-id" :title="scope.row.requestId">{{ scope.row.requestId }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="发生时间" width="170">
            <template slot-scope="scope">{{ $formatTime(scope.row.createdAt) }}</template>
          </el-table-column>
        </el-table>
      </div>

      <div class="mobile-only list-cards">
        <div v-for="(row, idx) in logs" :key="idx" class="list-card">
          <div class="card-header">
            <div style="flex:1;min-width:0;">
              <div class="card-title" style="color:#ef6d7a;font-size:13px;">{{ truncateText(row.errorMessage, 60) }}</div>
              <div class="card-sub">{{ row.className }}</div>
            </div>
          </div>
          <div style="font-size:12px;color:rgba(255,255,255,.6);margin-bottom:8px;">
            模型: {{ row.modelName }} · 账号: {{ row.accountUsername }} / {{ row.accountName }}
          </div>
          <div v-if="row.requestId" style="font-size:12px;color:rgba(255,255,255,.6);margin-bottom:8px;">
            Request ID: {{ row.requestId }}
          </div>
          <div class="meta-row">
            <span>{{ $formatTime(row.createdAt) }}</span>
          </div>
          <div class="card-actions">
            <el-button v-if="row.stackTrace" size="small" type="text" @click="showStack(row)">查看堆栈</el-button>
          </div>
        </div>
      </div>

      <el-pagination
        class="pagination-bar"
        layout="total, prev, pager, next"
        small
        :total="total"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        @current-change="onPageChange"
      />
    </section>

    <el-dialog title="异常堆栈" :visible.sync="stackVisible" width="700px">
      <pre class="dialog-body">{{ stackContent }}</pre>
    </el-dialog>
  </main>
</template>

<script>
export default {
  name: 'ErrorLogPage',
  data() {
    return {
      logs: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      searchQuery: '',
      startTime: '',
      endTime: '',
      stackVisible: false,
      stackContent: ''
    }
  },
  computed: {
    pageIndex() {
      return (this.currentPage - 1) * this.pageSize + 1
    }
  },
  mounted() {
    this.fetchLogs()
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page
      this.fetchLogs()
    },
    onSearch() {
      this.currentPage = 1
      this.fetchLogs()
    },
    onReset() {
      this.searchQuery = ''
      this.startTime = ''
      this.endTime = ''
      this.currentPage = 1
      this.fetchLogs()
    },
    showStack(row) {
      this.stackContent = row.stackTrace || '无'
      this.stackVisible = true
    },
    truncateText(text, maxLen) {
      if (!text) return '-'
      return text.length > maxLen ? text.substring(0, maxLen) + '...' : text
    },
    async fetchLogs() {
      try {
        const res = await this.$http.get('/admin/error-logs', {
          params: {
            keyword: this.searchQuery || undefined,
            startTime: this.startTime || undefined,
            endTime: this.endTime || undefined,
            page: this.currentPage,
            pageSize: this.pageSize
          }
        })
        this.logs = res.records || []
        this.total = Number(res.total) || 0
      } catch {
        this.$message.error('加载错误日志失败')
      }
    }
  }
}
</script>

<style scoped>
.error-log-page {
  padding: 18px 24px 76px;
}

.table-panel {
  padding: 16px;
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}

.table-panel ::v-deep .el-table,
.table-panel ::v-deep .el-table__header-wrapper,
.table-panel ::v-deep .el-table__body-wrapper {
  border-radius: var(--radius);
}

.table-panel ::v-deep th {
  background: rgba(255, 255, 255, 0.045);
  color: #9eb1ca;
  font-weight: 850;
}

.table-panel ::v-deep td,
.table-panel ::v-deep th {
  border-color: var(--line-soft);
}

.pagination-bar {
  margin-top: 20px;
  text-align: right;
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 18px;
  flex-wrap: wrap;
}

.search-input {
  width: 220px;
}

.error-msg {
  color: #ff93a4;
  cursor: default;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.request-id {
  font-family: var(--font-mono, monospace);
  font-size: 12px;
  color: #8fb8ff;
  cursor: default;
  white-space: nowrap;
}

.list-cards { display: grid; gap: 14px; }

.mobile-only { display: none; }

@media (max-width: 760px) {
  .desktop-only { display: none; }
  .mobile-only { display: block; }
  .error-log-page {
    padding: 12px 12px 28px;
  }
  .table-panel {
    padding: 10px;
    overflow-x: visible;
  }
  .toolbar {
    flex-wrap: wrap;
  }
  .date-picker-item {
    flex: 1;
    min-width: 0;
  }
  .search-input {
    flex: 1;
    min-width: 80px;
  }
  .pagination-bar {
    text-align: center;
  }
}
.list-card {
  padding: 16px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(27,39,58,.92), rgba(20,30,46,.88));
  border: 1px solid rgba(133,164,255,.12);
  box-shadow: 0 8px 28px rgba(0,0,0,.22);
  overflow: hidden;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 8px;
}
.card-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text);
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.card-sub {
  font-size: 12px;
  color: rgba(255,255,255,.4);
  margin-top: 2px;
}
.stats-row {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}
.stat-item {
  flex: 1;
  min-width: 0;
  background: rgba(255,255,255,.04);
  border-radius: 8px;
  padding: 8px 10px;
  text-align: center;
}
.stat-value {
  font-size: 14px;
  font-weight: 700;
  color: var(--text);
  line-height: 1.3;
}
.stat-label {
  font-size: 10px;
  color: rgba(255,255,255,.35);
  margin-top: 2px;
  letter-spacing: .02em;
}
.meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  padding-top: 10px;
  border-top: 1px solid rgba(133,164,255,0.06);
  margin-top: 6px;
  font-size: 11px;
  color: rgba(255,255,255,.35);
}
.card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding-top: 10px;
  border-top: 1px solid rgba(133,164,255,0.06);
  margin-top: 6px;
}
.card-actions .el-button--text {
  font-size: 12px;
  padding: 4px 10px;
  height: auto;
}

.dialog-body {
  background: rgba(255, 255, 255, 0.045);
  padding: 16px;
  border-radius: var(--radius);
  font-size: 12px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-all;
  margin: 0;
  max-height: 400px;
  overflow: auto;
}
</style>
